export default "43f61a8e60f460d4.svg"